import React, { Component } from 'react';
import { Card, CardHeader, CardBody, Row, Col, ListGroup, ListGroupItem, Label, Button } from 'reactstrap';
import Http from 'utils/http';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import './History.scss';

class History extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      selected: null,
      revisions: []
    };
  }

  componentDidMount() {
    const path = `${this.props.historyPath}/${this.props.match.params.id}/revisions/`;
    Http.get(path).then(data => {
      let sel = null;
      if (data.length > 0) {
        data[0].current = true;
        sel = data[0];
      }

      this.setState({
        revisions: data,
        selected: sel,
        isLoading: false
      });

      if (data.length > 0) {
        this.props.onHistorySelectedChange(sel);
      }
    });
  }

  renderRevisions() {
    let revs = null;
    if (this.state.revisions.length === 0) {
      revs = [this.renderNoRevision()];
    } else {
      revs = this.state.revisions.map(item => {
        return this.renderRevisionItem(item);
      });
    }

    return (
      <ListGroup>
        {revs}
      </ListGroup>
    );
  }

  renderRevisionActionData(item) {
    let items = [];
    const action = item.action.toUpperCase();

    let badgeClass = null;
    let label = action;
    if (item.current && action !== "DELETED") {
      badgeClass = "badge badge-secondary";
      label = "CURRENT VERSION";
    } else if (action === "DELETED") {
      badgeClass = "badge-danger";
    } else if (action === "RESTORED" || action === "CREATED") {
      badgeClass = "badge-warning";
    } else {
      badgeClass = "badge-primary";
    }

    if (item.stableVersion) {
      items.push(<Col key={'col_badges_' + item.id + '_' + item.revision}>
        <span className={"badge " + badgeClass}>{label}</span>
        <span className={"badge badge-success left-margin"}>{"STABLE"}</span>
      </Col>);
    } else if (item.integrationReleased) {
      items.push(<Col key={'col_badges_' + item.id + '_' + item.revision}>
        <span className={"badge " + badgeClass}>{label}</span>
        <span className={"badge badge-success left-margin"}>{"RELEASED"}</span>
      </Col>);
    } else {
      items.push(<Col key={'col_badges_' + item.id + '_' + item.revision}><span className={"badge " + badgeClass}>{label}</span></Col>);
    }

    items.push(<Col key={'col_users_' + item.id + '_' + item.revision} className="col-auto text-right">{item.changedByUser}</Col>);

    return items;
  }

  renderNoRevision() {
    return (
      <ListGroupItem key="no_history_group" className="list-group-item-action flex-column align-items-start">
        <Row>
          <Label className="align-middle text-center w-100">There are no histories</Label>
        </Row>
      </ListGroupItem>
    );
  }

  renderRevisionItem(item) {
    return (
      <ListGroupItem key={"lgi_item_" + item.id + "_" + item.revision} className="list-group-item-action flex-column align-items-start" color={this.state.selected.revision === item.revision ? "warning" : ""}
        onClick={() => {
          this.setState({
            selected: item
          });

          this.props.onHistorySelectedChange(item);
        }}>
        <Row>
          <Col className="col-9">
            <b><FormattedDate value={item.changedAt}
              year='numeric'
              month='numeric'
              day='numeric'
              hour='numeric'
              minute='numeric'
              second='numeric'
            /></b>
          </Col>
          <Col className="col-3 text-right">#{item.revision}</Col>
        </Row>
        <Row>
          {this.renderRevisionActionData(item)}
        </Row>

        {(item.tasyInterfacesMinVersion || item.tasyInterfacesMinBuild) &&
          (<Row>
            <Col className="col-6 text-left history-version">Tasy Min. Version: {item.tasyInterfacesMinVersion}</Col>
            <Col className="col-6 text-right history-version">Build: {item.tasyInterfacesMinBuild}</Col>
          </Row>)
        }

      </ListGroupItem>
    );
  }

  render() {
    return (
      <div className="d-none d-xl-block col-xl-3 floating-container history-container" >
        <Card>
          <CardHeader>
            <span>History</span>
            <div className="card-header-actions">
              <Button color="ghost-secondary" size="sm" onClick={this.props.onHistoryClose}>Close</Button>
            </div>
          </CardHeader>
          <CardBody className="p-0">

            {this.state.isLoading
              ? (<div className="m-4">Loading...</div>)
              : this.renderRevisions()
            }
          </CardBody>
        </Card>
      </div >
    );
  }

}

History.propTypes = {
  historyPath: PropTypes.string,
  onHistorySelectedChange: PropTypes.func,
  onHistoryOpen: PropTypes.func,
  onHistoryClose: PropTypes.func
}

History.defaultProps = {

}

export default History;
